// extracted by mini-css-extract-plugin
export default {"swatch":"ColorSwatch_swatch__T-aqI","square":"ColorSwatch_square__vdgOo","underline":"ColorSwatch_underline__dC510","selected":"ColorSwatch_selected__Monxu"};